var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh!important"}},[_c('div',{staticStyle:{"margin-top":"35vh!important"}},[_c('div',{staticClass:"text-center w3-center justify-center",staticStyle:{"margin":"0 auto!important"}},[_c('v-progress-circular',{attrs:{"size":"40","indeterminate":"","color":"#AB005E"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }